import configDefault from "./config-default";

const config = {
  ...configDefault,
  code: "magicformepone.fr",
  companyName: "MagicForm Epône",
  website: 'https://www.magicformepone.fr/',
  notifyChannel: 'vel-magicformepone',
  htmlCustomCSS: "magicformepone.scss",
  onlyOneClub: true,
	header: {
    title: "Je m'abonne",
		logo: "/magicform-black.jpg"
	},
  navigation: {
    ...configDefault.navigation,
    display: 'line',
  },
  payByCard: "PAYLINE",
  footer: {
    ...configDefault.footer,
    logo: "/magicform-black.jpg",
    textLine: null,
    cgv: {
      link: 'https://www.magicformepone.fr/mentions-legales/',
      text: 'Mentions légales'
    }
  },
  options: {
		title: "JE CHOISIS MES OPTIONS",
		message: "",
		nextLabel: "Suivant",
		useImg: false,
	},
  choice: {
    ...configDefault.choice,
    border: '#e0e0e0',
    border_selected: '#000000',
  },
  plans: {
    ...configDefault.plans,
    topOfferTitle: "Le + vendu",
  }

};

export default config;
